import axios from "axios";
//import { config } from "../config";
import { config } from "../config";
import reduxStore from "redux/store";
import { showErrorMessage } from "redux/actions/commonActions";
import { updateLoading } from "redux/actions/commonActions";
import store from "./../redux/store";
// const headers = {

//     "Content-Type": "application/json",

//     Accept: "application/json",

//     "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",

//     "Access-Control-Allow-Headers":

//         "Content-Type, Authorization, X-Requested-With",

//     "Access-Control-Allow-Credentials": "true",
//     "Authorization": "Bearer" + " " + store?.getState()?.claimCo?.loginData?.user_info?.token
// };

const instanceNew = axios.create({
  baseURL: config.apiUrl,
  headers: {
    tawuniyalead: false,
    authToken: null,
    requestId: null,
  },
  // headers
  // timeout: 1000,
  // headers: {'Content-Type': 'application/json','Accept':'application/json'}
});

const requestHandler = (request) => {
  return request;
};
instanceNew.interceptors.request.use(requestHandler);

const jtokenValue = store?.getState()?.sales?.encyptvalcust;

if (!jtokenValue) {
  console.log(jtokenValue, "ASD");
  instanceNew.interceptors.request.use((config) => {
    config.headers["jtoken"] = jtokenValue;
    return config;
  });
}

const isSuccess = (data) => {
  return (
    data &&
    ((data.resultCode && data.resultCode === "S") ||
      //Note: Required For Visit Visa APIs
      (data.status && (data.status === "1" || data.status == "Success" || data.status == "S")) ||
      (data.status && data.status === "1") ||
      (data && data.GetBeneficariesDetailsResult))
  );
};

const getErrorMessage = (data) => {
  if (data.resultCode) {
    return data.resultMessage;
  }
  if (data.status) {
    if (data.resultDesc) {
      return data.resultDesc;
    }
    if (data.statusDescritpion) {
      return data.statusDescritpion;
    }
    if (data.errorDesc) {
      return data.errorDesc;
    }
  }
};

const responseHandler = (response) => {
  if (!isSuccess(response.data)) {
    return errorHandler({ message: getErrorMessage(response.data) });
  }
  return response;
};

const errorHandler = (error) => {
  reduxStore.dispatch(updateLoading(false));
  if (error.message.includes("/policyNo")) {
  } else if (error.message.includes("/policyNo")) {
    reduxStore.dispatch(showErrorMessage("We Could Not Connect, Please Try Again Later"));
  } else {
    reduxStore.dispatch(showErrorMessage(error.message));
  }

  setTimeout(() => {
    reduxStore.dispatch(showErrorMessage(""));
  }, 500);
  return Promise.reject(error);
};

// instance.interceptors.request.use(requestHandler,errorHandler);
// instance.interceptors.response.use(responseHandler,errorHandler);

//-------------------------------------------------------------------------
const getJwtToken = () => store.getState().common.JWT;
const getrequestId = () => store.getState().common.requestId;

export const securedAxiosInstance = axios.create({
  baseURL: config.apiUrl,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${getJwtToken()}`
  },
});

securedAxiosInstance.interceptors.request.use(
  (config) => {
    config.headers.Authorization = `Bearer ${getJwtToken()}`;
    config.headers.authToken = `${getJwtToken()}`;
    config.headers.requestId = `${getrequestId()}`;
    return config;
  },
  (error) => Promise.reject(error)
);
//-----

export default instanceNew;
